export default __webpack_public_path__ + "static/spring_renard-6fceff71a60e22d5328a35a204c4c22d.png";